import { ICustomUrl } from "@edp-models/deep-link.model";

export interface IDeepLinkState {
    deepLink: ICustomUrl;
}

export const initialDeepLinkState: IDeepLinkState = {
    deepLink: null
};
